/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var a;!function(a){a[a.EnableFastUpdates=0]="EnableFastUpdates",a[a.DisableFastUpdates=1]="DisableFastUpdates",a[a.UpdateFastLocalOrigin=2]="UpdateFastLocalOrigin"}(a||(a={}));export{a as MeshTransformUpdateAction};
